import {
  AttachFile,
  Close,
  InsertDriveFile,
  Send,
  Image,
  Movie,
} from "@mui/icons-material";

import {
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/material";
import { useRef, useState } from "react";
import { useAppSelector } from "../../app/hooks";
import { selectCredentials } from "../../features/credentials/credentialsSlice";
import { selectChatState } from "../../features/settings/settingsSlice";
import { selectToken } from "../../features/token/tokenSlice";
import { useHttpEscalloChatService } from "../../service/http.escallo-chat.service";

export const BottomChat = ({ styles, send, disabled }: any) => {
  const [currentMessage, setCurrentMessage] = useState<string>("");
  // const [file, setFile] = useState(null);
  const hiddenFileInputImage = useRef<any>(null);
  const hiddenFileInputVideo = useRef<any>(null);
  const hiddenFileInputDocument = useRef<any>(null);
  const chatState = useAppSelector(selectChatState);
  const credentials = useAppSelector(selectCredentials);
  const tokenChat = useAppSelector(selectToken);
  const escalloChatHttpService = useHttpEscalloChatService();

  function isBlank(str: string) {
    return !str || /^\s*$/.test(str);
  }

  function onSendMessage(event: any) {
    event.preventDefault();
    if (!isBlank(currentMessage)) {
      send.message(currentMessage.trim());
      setCurrentMessage("");
    }
  }

  function onChangeMessage(event: any) {
    if (!(event.nativeEvent.data === " " && isBlank(currentMessage))) {
      setCurrentMessage(event.target.value);
    }
  }

  function uploadImage(event: any) {
    const [file] = event.target.files;
    if (!file || !credentials) {
      return;
    }
    escalloChatHttpService
      .uploadFile(tokenChat, credentials.tokenSessionUser as any, file)
      .then((res: any) => {
        send.image(res.path, res.mimeType, res.externalDownload);
        hiddenFileInputImage.current.value = "";
      });
  }

  function uploadVideo(event: any) {
    const [file] = event.target.files;
    if (!file || !credentials) {
      return;
    }
    escalloChatHttpService
      .uploadFile(tokenChat, credentials.tokenSessionUser as any, file)
      .then((res: any) => {
        send.video(res.path, res.mimeType, res.externalDownload);
        hiddenFileInputVideo.current.value = "";
      });
  }

  function uploadDoc(event: any) {
    const [file] = event.target.files;
    if (!file || !credentials) {
      return;
    }
    escalloChatHttpService
      .uploadFile(tokenChat, credentials.tokenSessionUser as any, file)
      .then((res: any) => {
        send.document(res.path, res.mimeType, res.externalDownload);
        hiddenFileInputDocument.current.value = "";
      });
  }

  const [speedDial, setSpeedDial] = useState(false);
  const handleSpeedDialOpen = (event: any) => setSpeedDial(!speedDial);

  return (
    <Box sx={styles.bottom}>
      <Box sx={styles.sendWrapper}>
        <Box component="form" sx={styles.sendForm} onSubmit={onSendMessage}>
          <Box
            sx={{ display: "flex", alignItems: "flex-end" }}
            onMouseLeave={() => setSpeedDial(false)}
          >
            <Tooltip title="Compartilhar arquivo">
              <SpeedDial
                ariaLabel="Anexar"

                onClick={handleSpeedDialOpen}
                open={chatState ? speedDial : false}
                sx={styles.speedDial}
                icon={
                  <SpeedDialIcon icon={<AttachFile />} openIcon={<Close />} />
                }
              >
                <SpeedDialAction
                  key="speed-dial-document"
                  icon={<InsertDriveFile />}
                  onClick={(e: any) => {
                    (chatState || !disabled) &&
                      hiddenFileInputDocument.current.click();
                  }}
                  tooltipTitle="Documento"
                  color="red"
                />
                <SpeedDialAction
                  key="speed-dial-photo"
                  icon={<Image />}
                  onClick={(e: any) => {
                    (chatState || !disabled) &&
                      hiddenFileInputImage.current.click();
                  }}
                  tooltipTitle="Imagens"
                />
                <SpeedDialAction
                  key="speed-dial-video"
                  icon={<Movie />}
                  onClick={(e: any) => {
                    (chatState || !disabled) &&
                      hiddenFileInputVideo.current.click();
                  }}
                  tooltipTitle="Videos"
                />
              </SpeedDial>
            </Tooltip>
          </Box>
          
          <TextField
            id="input-text-chat"
            placeholder="Digite uma mensagem"
            variant="outlined"
            margin="none"
            multiline
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                onSendMessage(e);
              }
            }}
            autoFocus
            maxRows={4}
            fullWidth
            disabled={disabled || !chatState}
            sx={styles.textInput}
            onChange={onChangeMessage}
            value={currentMessage}
          />
          <input
            type={"file"}
            style={{ display: "none" }}
            ref={hiddenFileInputImage}
            onChange={uploadImage}
            accept="image/*"
            disabled={disabled || !chatState}
          />
          <input
            type={"file"}
            style={{ display: "none" }}
            ref={hiddenFileInputVideo}
            onChange={uploadVideo}
            accept="video/*"
            disabled={disabled || !chatState}
          />
          <input
            type={"file"}
            style={{ display: "none" }}
            ref={hiddenFileInputDocument}
            onChange={uploadDoc}
            disabled={disabled || !chatState}
            accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          />
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <Tooltip title="Enviar">
              <IconButton
                aria-label="Enviar"
                type="submit"
                disabled={disabled || !chatState}
              >
                <Send />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
